var map = {
	"./Employee.svg": "8758",
	"./Enterprise.svg": "543f",
	"./Individual.svg": "eb3e",
	"./arrow.svg": "b6e4",
	"./auth.svg": "4e70",
	"./chenggong.svg": "42b9",
	"./click.svg": "6079",
	"./close.svg": "7710",
	"./default-user.svg": "c4ad",
	"./delete.svg": "59a1",
	"./down-arrow.svg": "00ea",
	"./edit.svg": "aa46",
	"./fail_icon.svg": "1155",
	"./gitee-fill-round.svg": "56e3",
	"./gitee_new.svg": "71ac",
	"./giteelogin.svg": "5c3a",
	"./github.svg": "558d",
	"./github_new.svg": "d858",
	"./githublogin.svg": "c6bd",
	"./logo.svg": "bb69",
	"./manage.svg": "723e",
	"./menu.svg": "bd3d",
	"./operation.svg": "1c17",
	"./pdf.svg": "f9a1",
	"./repository.svg": "11f0",
	"./right-arrow.svg": "8e1e",
	"./send.svg": "94d0",
	"./sign.svg": "2496",
	"./success.svg": "a8cf",
	"./tips.svg": "6878",
	"./warning.svg": "7e6f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";